import React from 'react'
import './WordCloud.css'
const d3 = require('d3')
const cloud = require('d3-cloud')

const COLORS = {
  1: '#3F51B5', // indigo
  2: '#FF5722', // deeporange
  3: '#009688', // teal
  4: '#607D8B', // bluegrey
  5: '#E91E63', // pink
}

export default class WordCloud extends React.Component {
  componentDidMount() {
    this.renderWordCloud()
  }

  renderWordCloud() {
    const words = this.getWords()
    const layout = cloud()
      .size([800, 400])
      .words(words)
      .padding(5)
      .rotate(function() { return ~~(Math.random() * 2) * 90; })
      .font('ps')
      .fontSize(function(d) { return d.size; })
      .on('end', draw);

    layout.start();

    function draw(words) {
      d3.select('div.cloud').append('svg')
        .attr('width', layout.size()[0])
        .attr('height', layout.size()[1])
        .attr('viewBox', '0 0 ' + layout.size()[0] + ' ' + layout.size()[1])
        .style('width', '100%')
        .style('height', 'auto')
      .append('g')
        .attr('transform', 'translate(' + layout.size()[0] / 2 + ',' + layout.size()[1] / 2 + ')')
      .selectAll('text')
        .data(words)
      .enter().append('text')
        .style('font-size', function(d) { return d.size; })
        .style('font-family', 'ps, roboto')
        .style('fill', function(d) {return d.color})
        .attr('text-anchor', 'middle')
        .attr('transform', function(d) {
          return 'translate(' + [d.x, d.y] + ')rotate(' + d.rotate + ')';
        })
        .text(function(d) { return d.text; });
    }
  }

  getWords() {
    const { data } = this.props.widget

    return data.map(word => {
      const { title, size } = word
      return { text: title, size: size * 15, color: this.getColor(size)  }
    })
  }

  getColor(size) {
    return COLORS[size]
  }

  render() {
    return (
      <div>
        <div className='cloud'></div>
      </div>
    )
  }
}
